import { GatsbyImage } from "gatsby-plugin-image";
import React, { useState } from "react";
import { toast } from "react-hot-toast";

const Popup = ({ isOpen, onClose, data }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  if (!isOpen) return null;

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    const obj = {
      data: {
        email: email,
        date: new Date().toUTCString(),
        website: window.location.origin,
      },
      sheetID: 40,
    };
    fetch("https://leads.civsav.com/template/contact", {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);
        setEmail("");
        toast.success("Subscribed successfully. Thanks! ");
        onClose();
      })
      .catch(() => {
        toast.error("Something went wrong! Please try again");
        setLoading(false);
        onClose();
      });
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-5 z-50"
      role="dialog"
    >
      <div className="bg-white rounded p-10 w-full max-w-xl relative min-h-96 flex items-center text-center bg-black/20">
        <div className="absolute inset-0 w-full h-full">
          <GatsbyImage
            image={data.image.asset.gatsbyImageData}
            alt={data.heading}
            objectFit="cover"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-black/30 flex items-center w-full h-full z-[60]">
          <button
            className="absolute top-3 right-3 text-white/80 hover:text-white"
            onClick={onClose}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div className="max-w-md w-full mx-auto px-5">
            <h2 className="text-white text-2xl sm:text-3xl font-bold">
              {data.heading}
            </h2>
            <h2 className="text-white mb-2 text-base sm:text-lg">
              {data.subheading}
            </h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 text-black border border-solid border-black rounded focus:outline-none"
              />
              <button
                type="submit"
                aria-label="Subscribe"
                className="w-full h-10 text-center flex items-center justify-center px-4 py-2 text-lg border border-solid font-bold rounded font-nunito
          bg-secondary text-white border-secondary hover:bg-white hover:text-secondary"
              >
                {loading ? "Subscribing..." : "Subscribe"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
